<template>
  <teleport v-if="showAlerty" to="body">
    <div
      class="alerty w-full flex justify-center items-center fixed top-[55px] left-0 mx-auto px-5 z-50"
    >
      <div
        class="flex justify-start items-center gap-[5px] min-w-[335px] w-max  max-w-full py-[10px] pl-[10px] pr-8 bg-[#344425] border border-button-border-wasabiborder rounded-xl"
      >
        <div>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_22832_4052)">
              <rect
                width="24"
                height="24"
                rx="12"
                fill="#009D0A"
                fill-opacity="0.1"
              />
              <path
                d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7473 9.41498 20.7192 6.93661 18.8913 5.10872C17.0634 3.28084 14.585 2.25273 12 2.25ZM16.2806 10.2806L11.0306 15.5306C10.961 15.6004 10.8783 15.6557 10.7872 15.6934C10.6962 15.7312 10.5986 15.7506 10.5 15.7506C10.4014 15.7506 10.3038 15.7312 10.2128 15.6934C10.1218 15.6557 10.039 15.6004 9.96938 15.5306L7.71938 13.2806C7.57865 13.1399 7.49959 12.949 7.49959 12.75C7.49959 12.551 7.57865 12.3601 7.71938 12.2194C7.86011 12.0786 8.05098 11.9996 8.25 11.9996C8.44903 11.9996 8.6399 12.0786 8.78063 12.2194L10.5 13.9397L15.2194 9.21937C15.2891 9.14969 15.3718 9.09442 15.4628 9.0567C15.5539 9.01899 15.6515 8.99958 15.75 8.99958C15.8486 8.99958 15.9461 9.01899 16.0372 9.0567C16.1282 9.09442 16.2109 9.14969 16.2806 9.21937C16.3503 9.28906 16.4056 9.37178 16.4433 9.46283C16.481 9.55387 16.5004 9.65145 16.5004 9.75C16.5004 9.84855 16.481 9.94613 16.4433 10.0372C16.4056 10.1282 16.3503 10.2109 16.2806 10.2806Z"
                fill="#75B13B"
              />
            </g>
            <defs>
              <clipPath id="clip0_22832_4052">
                <rect width="24" height="24" rx="12" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>

        <div class="flex justify-center items-center">
            <span class="text-sm font-medium font-inter text-white">{{ $t(alert, param) }}</span>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script lang="ts" setup>
const alertyStore =  useAlertyStore()
const { alert, showAlerty, param } = storeToRefs(alertyStore)
</script>

<style lang="scss" scoped>
.alerty {
    animation: slideDown 0.5s ease-in-out;
}

@keyframes slideDown {
    0% {
        opacity: 0;
        transform: translateY(-50px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>
